export default __webpack_public_path__ + "static/media/bg-login.b91dfb48.jpg";